import React from 'react';

const Alert = ({
  id, // Unique identifier for the alert
  type, // Alert type (e.g., "success", "error", "info")
  title, // Title for the alert
  message, // Main message/content for the alert
  visible, // Controls whether the alert is shown
  onClose, // Function to handle when the alert is dismissed
  icon, // Optional icon JSX for the alert
  link, // Optional link object { href, text }
}) => {
  if (!visible) return null; // Don't render if not visible

  // Define styles based on alert type
  const typeStyles = {
    success:
      'text-green-800 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-800 dark:border-green-800',
    error:
      'text-red-800 border-red-300 bg-red-50 dark:text-red-400 dark:bg-gray-800 dark:border-red-800',
    info: 'text-blue-800 border-blue-300 bg-blue-50 dark:text-blue-400 dark:bg-gray-800 dark:border-blue-800',
  };

  // Check if the title ends with punctuation
  const endsWithPunctuation = /[?!.]$/.test(title);

  // Get device type to apply additional styling if this is a mobile sticky alert
  const isMobileId = id?.includes('-mobile');

  return (
    <div
      id={id}
      className={`flex items-center p-4 ${isMobileId ? 'shadow-lg mb-0' : ''} border-t-4 ${typeStyles[type]} w-full`}
      role="alert"
    >
      <div className="inline-flex items-center mx-auto">
        {/* Optional Icon */}
        {icon && <span className="mr-2">{icon}</span>}

        {/* Alert Content */}
        <div className="text-sm font-medium text-center">
          <strong>{title}</strong>
          {!endsWithPunctuation && ':'} {message}{' '}
          {link && (
            <a href={link.href} className="underline">
              {link.text}
            </a>
          )}
        </div>

        {/* Dismiss Button */}
        <button
          type="button"
          className="ms-auto -mx-1.5 -my-1.5 bg-transparent text-current rounded-lg focus:ring-2 p-1.5 hover:bg-opacity-75 inline-flex items-center justify-center h-8 w-8"
          aria-label="Close"
          onClick={onClose}
        >
          <svg
            className="w-3 h-3"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M1 1l12 12M13 1L1 13" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Alert;
